import { render, staticRenderFns } from "./BarChartViz.vue?vue&type=template&id=64285508&scoped=true&"
import script from "./BarChartViz.vue?vue&type=script&lang=js&"
export * from "./BarChartViz.vue?vue&type=script&lang=js&"
import style0 from "./BarChartViz.vue?vue&type=style&index=0&id=64285508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64285508",
  null
  
)

export default component.exports